module.exports = __webpack_public_path__ + "static/media/metronom.697cfd8d.svg";